import {
    TaxCreateConfirmedPayload,
    TaxCreatedPayload,
    TaxCreateFailedPayload,
    TaxCreateRequestedPayload,
    TaxUpdateConfirmedPayload,
    TaxUpdatedPayload,
    TaxUpdateFailedPayload,
    TaxUpdateRequestedPayload,
} from "./Taxation/types"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { TimeRecord, TimeRecordUpdateBody } from "./TimeRecord/types"
import { CardState } from "./CardProgramCard/types"
import { TimeRecordBreakInputBody, TimeRecordCreateBreakData } from "./TimeRecordBreak/types"
import { SignUpConfirmedPayload, SignUpRequestedPayload } from "../components/screens/signUp/types"
import { User } from "./User/types"
import { Organization, OrganizationUserAccount } from "./Organization/types"
import { AccessLevelEventDTO, Account } from "./Account/types"
import { SalesInputCreateRequestedPayload, SalesInputFolderUpdateRequestedPayload } from "./SalesInput/types"
import { PromotionCreateRequestedPayload } from "./Promotions/types"
import {
    EmployeeCreateRequestedEventData,
    EmployeeDeleteRequestedEventData,
    EmployeeUpdateRequestedEventData,
} from "../components/screens/employees/employees/types"
import {
    CategoryAddRequestedPayload,
    CategoryUpdateRequestedPayload,
    ProductAddRequestedPayload,
    ProductUpdateRequestedPayload,
} from "./Category/types"
import {
    ModifierAddRequestedPayload,
    ModifierConfirmedPayload,
    ModifierGroupAddRequestedPayload,
    ModifierGroupAddResponsePayload,
    ModifierGroupUpdateRequestedPayload,
    ModifierGroupUpdateResponsePayload,
} from "./modifier/types"
import { DepartmentEventPayload, RoleEventPayload } from "./Role/types"
import { AuditData, UpdateSettingsRequestedPayload } from "./Setting/types"
import {
    GatewayCredentialsMap,
    PaymentCredentialsValidationRequestedPayload,
} from "../components/screens/settings/paymentSettings/GatewaySettings/hooksActions"
import {
    LoyaltyProgramAddedPayload,
    LoyaltyProgramDeletedPayload,
    LoyaltyProgramUpdatedPayload,
} from "../components/screens/settings/types"
import { TerminalAddRequestedPayload, TerminalUpdateRequestedPayload } from "./Terminal/types"
import { FigureQrConfigurationSaveRequestedPayload } from "./figureQR/types"
import { WaitlistSaveRequestedPayload } from "./waitlist/types"
import {
    AccessLevelDeleteConfirmedPayload,
    AccessLevelDeleteRequestedPayload,
    AccessLevelSaveConfirmedPayload,
    AccessLevelSaveRequestedPayload,
} from "./access/types"
import { FeatureTrackedPayload } from "../components/screens/organization/FeatureTracking/types"
import { MenuImportConfirmedPayload, MenuImportFailedPayload, MenuImportRequestedPayload } from "./MenuImport/types"
import { OptionGroupAddRequestedPayload, OptionGroupAddResponsePayload } from "./option/types"
import {
    CustomerAddressUpdateRequestedPayload,
    CustomerDeleteRequestedPayload,
    CustomerLoyaltyProgramCreateRequestedPayload,
    CustomerLoyaltyProgramRemoveRequestedPayload,
    CustomerUpdateRequestedPayload,
} from "./Customer/types"

export enum EventType {
    EmployeeUpdateRequested = "EmployeeUpdateRequested",
    EmployeeCreateRequested = "EmployeeCreateRequested",
    EmployeeDeleteRequested = "EmployeeDeleteRequested",

    PaymentCredentialsValidationRequested = "PaymentCredentialsValidationRequested",

    CategoryAddRequested = "CategoryAddRequested",
    CategoryAddConfirmed = "CategoryAddConfirmed",
    CategoryAddFailed = "CategoryAddFailed",

    CategoryUpdateRequested = "CategoryUpdateRequested",
    CategoryUpdateFailed = "CategoryUpdateFailed",
    CategoryUpdateConfirmed = "CategoryUpdateConfirmed",

    CategoryDeleteRequested = "CategoryDeleteRequested",
    CategoryDeleteConfirmed = "CategoryDeleteConfirmed",
    CategoryDeleteFailed = "CategoryDeleteFailed",

    ProductAddRequested = "ProductAddRequested",
    ProductAddConfirmed = "ProductAddConfirmed",
    ProductAddFailed = "ProductAddFailed",

    ProductUpdateRequested = "ProductUpdateRequested",
    ProductUpdateConfirmed = "ProductUpdateConfirmed",
    ProductUpdateFailed = "ProductUpdateFailed",

    ProductsDeleteRequested = "ProductsDeleteRequested",
    ProductsDeleteResponse = "ProductsDeleteResponse",
    ProductsDeleteFailed = "ProductsDeleteFailed",

    OptionGroupAddRequested = "OptionGroupAddRequested",
    OptionGroupAddConfirmed = "OptionGroupAddConfirmed",
    OptionGroupAddFailed = "OptionGroupAddFailed",

    OptionGroupsDeleteRequested = "OptionGroupsDeleteRequested",
    OptionGroupsDeleteConfirmed = "OptionGroupsDeleteConfirmed",
    OptionGroupsDeleteFailed = "OptionGroupsDeleteFailed",

    ModifierGroupsDeleteRequested = "ModifierGroupsDeleteRequested",
    ModifierGroupsDeleteConfirmed = "ModifierGroupsDeleteConfirmed",
    ModifierGroupsDeleteFailed = "ModifierGroupsDeleteFailed",

    ModifierGroupAddRequested = "ModifierGroupAddRequested",
    ModifierGroupAddConfirmed = "ModifierGroupAddConfirmed",
    ModifierGroupAddFailed = "ModifierGroupAddFailed",

    ModifierGroupUpdateRequested = "ModifierGroupUpdateRequested",
    ModifierGroupUpdateConfirmed = "ModifierGroupUpdateConfirmed",
    ModifierGroupUpdateFailed = "ModifierGroupUpdateFailed",

    ModifierAddRequested = "ModifierAddRequested",
    ModifierAddConfirmed = "ModifierAddConfirmed",
    ModifierAddFailed = "ModifierAddFailed",

    OnlineOrderingIntegrationRequested = "OnlineOrderingIntegrationRequested",
    UberDirectOrganizationCreateRequested = "UberDirectOrganizationCreateRequested",

    DomainImportRequested = "DomainImportRequested",
    DomainImportConfirmed = "DomainImportConfirmed",
    DomainImportFailed = "DomainImportFailed",
    DomainActivationRequested = "DomainActivationRequested",
    DomainDeactivationRequested = "DomainDeactivationRequested",
    DomainRemoveRequested = "DomainRemoveRequested",
    UberMerchantAuthorizationRequested = "UberMerchantAuthorizationRequested",

    TaxCreateRequested = "TaxCreateRequested",
    TaxCreateConfirmed = "TaxCreateConfirmed",
    TaxCreateFailed = "TaxCreateFailed",
    TaxCreated = "TaxCreated",

    AccountInfoUpdateRequested = "AccountInfoUpdateRequested",
    AccountInfoUpdateConfirmed = "AccountInfoUpdateConfirmed",
    AccountInfoUpdateFailed = "AccountInfoUpdateFailed",

    AccountUserAddRequested = "AccountUserAddRequested",
    AccountUserRemoveRequested = "AccountUserRemoveRequested",

    AccountUpdateRequested = "AccountUpdateRequested",
    AccountUpdateFailed = "AccountUpdateFailed",
    AccountUpdateConfirmed = "AccountUpdateConfirmed",

    AccessLevelSaveRequested = "AccessLevelSaveRequested",
    AccessLevelSaveConfirmed = "AccessLevelSaveConfirmed",
    AccessLevelDeleteRequested = "AccessLevelDeleteRequested",
    AccessLevelDeleteConfirmed = "AccessLevelDeleteConfirmed",

    TaxUpdateRequested = "TaxUpdateRequested",
    TaxUpdateConfirmed = "TaxUpdateConfirmed",
    TaxUpdateFailed = "TaxUpdateFailed",
    TaxUpdated = "TaxUpdated",

    TaxDeleteRequested = "TaxDeleteRequested",
    TaxDeleteConfirmed = "TaxDeleteConfirmed",
    TaxDeleteFailed = "TaxDeleteFailed",
    TaxDeleted = "TaxDeleted",

    TimeRecordCreateRequested = "TimeRecordCreateRequested",
    TimeRecordCreated = "TimeRecordCreated",
    TimeRecordCreateFailed = "TimeRecordCreateFailed",
    TimeRecordCreateConfirmed = "TimeRecordCreateConfirmed",
    TimeRecordUpdateRequested = "TimeRecordUpdateRequested",
    TimeRecordUpdated = "TimeRecordUpdated",
    TimeRecordUpdateFailed = "TimeRecordUpdateFailed",
    TimeRecordUpdateConfirmed = "TimeRecordUpdateConfirmed",
    TimeRecordDeleteRequested = "TimeRecordDeleteRequested",
    TimeRecordDeleted = "TimeRecordDeleted",
    TimeRecordDeleteFailed = "TimeRecordDeleteFailed",
    TimeRecordDeleteConfirmed = "TimeRecordDeleteConfirmed",

    TimeRecordBreakCreateRequested = "TimeRecordBreakCreateRequested",
    TimeRecordBreakCreated = "TimeRecordBreakCreated",
    TimeRecordBreakCreateFailed = "TimeRecordBreakCreateFailed",
    TimeRecordBreakCreateConfirmed = "TimeRecordBreakCreateConfirmed",
    TimeRecordBreakUpdateRequested = "TimeRecordBreakUpdateRequested",
    TimeRecordBreakUpdated = "TimeRecordBreakUpdated",
    TimeRecordBreakUpdateFailed = "TimeRecordBreakUpdateFailed",
    TimeRecordBreakUpdateConfirmed = "TimeRecordBreakUpdateConfirmed",
    TimeRecordBreakDeleteRequested = "TimeRecordBreakDeleteRequested",
    TimeRecordBreakDeleted = "TimeRecordBreakDeleted",
    TimeRecordBreakDeleteFailed = "TimeRecordBreakDeleteFailed",
    TimeRecordBreakDeleteConfirmed = "TimeRecordBreakDeleteConfirmed",

    CardProgramCardStateUpdateRequested = "CardProgramCardStateUpdateRequested",
    CardProgramCardStateUpdated = "CardProgramCardStateUpdated",
    CardProgramCardStateUpdateFailed = "CardProgramCardStateUpdateFailed",
    CardProgramCardStateUpdateConfirmed = "CardProgramCardStateUpdateConfirmed",

    PasswordResetRequested = "PasswordResetRequested",
    PasswordResetConfirmed = "PasswordResetConfirmed",
    PasswordResetFailed = "PasswordResetFailed",

    PasswordChangeRequested = "PasswordChangeRequested",
    PasswordChangeConfirmed = "PasswordChangeConfirmed",
    PasswordChangeFailed = "PasswordChangeFailed",

    SignupRequested = "SignupRequested",
    SignupConfirmed = "SignupConfirmed",
    SignupFailed = "SignupFailed",

    // Account
    AccountCreateRequested = "AccountCreateRequested",
    AccountCreateFailed = "AccountCreateFailed",
    AccountCreated = "AccountCreated",
    AccountCreateConfirmed = "AccountCreateConfirmed",

    // Organization
    OrganizationCreateRequested = "OrganizationCreateRequested",
    OrganizationCreateFailed = "OrganizationCreateFailed",
    OrganizationCreated = "OrganizationCreated",
    OrganizationCreateConfirmed = "OrganizationCreateConfirmed",

    OrganizationUserAddRequested = "OrganizationUserAddRequested",
    OrganizationUserAddFailed = "OrganizationUserAddFailed",
    OrganizationUserAdded = "OrganizationUserAdded",
    OrganizationUserAddConfirmed = "OrganizationUserAddConfirmed",

    OrganizationUserRemoveRequested = "OrganizationUserRemoveRequested",
    OrganizationUserRemoveFailed = "OrganizationUserRemoveFailed",
    OrganizationUserRemoved = "OrganizationUserRemoved",
    OrganizationUserRemoveConfirmed = "OrganizationUserRemoveConfirmed",

    CustomersImportRequested = "CustomersImportRequested",
    CustomersImportConfirmed = "CustomersImportConfirmed",
    CustomersImportFailed = "CustomersImportFailed",

    CustomerUpdateRequested = "CustomerUpdateRequested",
    CustomerUpdateConfirmed = "CustomerUpdateConfirmed",
    CustomerUpdateFailed = "CustomerUpdateFailed",

    CustomerAddressUpdateRequested = "CustomerAddressUpdateRequested",
    CustomerAddressUpdateConfirmed = "CustomerAddressUpdateConfirmed",
    CustomerAddressUpdateFailed = "CustomerAddressUpdateFailed",

    CustomerLoyaltyProgramCreateRequested = "CustomerLoyaltyProgramCreateRequested",
    CustomerLoyaltyProgramCreateConfirmed = "CustomerLoyaltyProgramCreateConfirmed",
    CustomerLoyaltyProgramCreateFailed = "CustomerLoyaltyProgramCreateFailed",

    CustomerLoyaltyProgramRemoveRequested = "CustomerLoyaltyProgramRemoveRequested",
    CustomerLoyaltyProgramRemoveConfirmed = "CustomerLoyaltyProgramRemoveConfirmed",
    CustomerLoyaltyProgramRemoveFailed = "CustomerLoyaltyProgramRemoveFailed",

    CustomerDeleteRequested = "CustomerDeleteRequested",
    CustomerDeleteConfirmed = "CustomerDeleteConfirmed",
    CustomerDeleteFailed = "CustomerDeleteFailed",

    MenuImportRequested = "MenuImportRequested",
    MenuImportConfirmed = "MenuImportConfirmed",
    MenuImportFailed = "MenuImportFailed",

    SalesInputCreateRequested = "SalesInputCreateRequested",

    SalesInputFolderUpdateRequested = "SalesInputFolderUpdateRequested",
    SalesInputFolderUpdateConfirmed = "SalesInputFolderUpdateConfirmed",
    SalesInputFolderUpdateFailed = "SalesInputFolderUpdateFailed",

    // Promotions
    PromotionCreateRequested = "PromotionCreateRequested",
    PromotionCreateFailed = "PromotionCreateFailed",
    PromotionCreateConfirmed = "PromotionCreateConfirmed",

    PromotionUpdateRequested = "PromotionUpdateRequested",
    PromotionUpdateFailed = "PromotionUpdateFailed",
    PromotionUpdateConfirmed = "PromotionUpdateConfirmed",

    PromotionDeleteRequested = "PromotionDeleteRequested",
    PromotionDeleteFailed = "PromotionDeleteFailed",
    PromotionDeleteConfirmed = "PromotionDeleteConfirmed",

    // New Role Events
    RoleAddRequested = "RoleAddRequested",
    RoleAddFailed = "RoleAddFailed",
    RoleAddConfirmed = "RoleAddConfirmed",

    RoleUpdateRequested = "RoleUpdateRequested",
    RoleUpdateFailed = "RoleUpdateFailed",
    RoleUpdateConfirmed = "RoleUpdateConfirmed",

    RoleDeleteRequested = "RoleDeleteRequested",
    RoleDeleteConfirmed = "RoleDeleteConfirmed",
    RoleDeleteFailed = "RoleDeleteFailed",

    // New Department Events
    DepartmentAddRequested = "DepartmentAddRequested",
    DepartmentAddFailed = "DepartmentAddFailed",
    DepartmentAddConfirmed = "DepartmentAddConfirmed",

    DepartmentUpdateRequested = "DepartmentUpdateRequested",
    DepartmentUpdateFailed = "DepartmentUpdateFailed",
    DepartmentUpdateConfirmed = "DepartmentUpdateConfirmed",

    DepartmentDeleteRequested = "DepartmentDeleteRequested",
    DepartmentDeleteFailed = "DepartmentDeleteFailed",
    DepartmentDeleteConfirmed = "DepartmentDeleteConfirmed",

    SettingsUpdateRequested = "SettingsUpdateRequested",
    SettingsUpdateConfirmed = "SettingsUpdateConfirmed",
    SettingsUpdateFailed = "SettingsUpdateFailed",
    SettingUpdated = "SettingUpdated",

    LoyaltyProgramAddRequested = "LoyaltyProgramAddRequested",
    LoyaltyProgramUpdateRequested = "LoyaltyProgramUpdateRequested",
    LoyaltyProgramDeleteRequested = "LoyaltyProgramDeleteRequested",

    ExternalServiceIntegrationCreateRequested = "ExternalServiceIntegrationCreateRequested",
    ExternalServiceIntegrationRemoved = "ExternalServiceIntegrationRemoved",

    // Google Business Review Reply
    GoogleBusinessReviewReplyRequested = "GoogleBusinessReviewReplyRequested",
    GoogleBusinessReviewReplyConfirmed = "GoogleBusinessReviewReplyConfirmed",
    GoogleBusinessReviewReplyFailed = "GoogleBusinessReviewReplyFailed",
    GoogleBusinessReviewReplyDeleteRequested = "GoogleBusinessReviewReplyDeleteRequested",
    GoogleBusinessReviewReplyDeleteConfirmed = "GoogleBusinessReviewReplyDeleteConfirmed",
    GoogleBusinessReviewReplyDeleteFailed = "GoogleBusinessReviewReplyDeleteFailed",

    // Terminal events
    TerminalAddRequested = "TerminalAddRequested",
    TerminalUpdateRequested = "TerminalUpdateRequested",
    TerminalDeleteRequested = "TerminalDeleteRequested",

    // Figure QR
    FigureQrConfigurationSaveRequested = "FigureQrConfigurationSaveRequested",

    // Waitlist
    WaitlistSaveRequested = "WaitlistSaveRequested",

    // Analytics
    FeatureTracked = "FeatureTracked",

    // Card Program
    CardProgramSaveRequested = "CardProgramSaveRequested",
    CardProgramDeleteRequested = "CardProgramDeleteRequested",
}

export type Payload = {
    [EventType.EmployeeUpdateRequested]: EmployeeUpdateRequestedEventData
    [EventType.EmployeeCreateRequested]: EmployeeCreateRequestedEventData
    [EventType.EmployeeDeleteRequested]: EmployeeDeleteRequestedEventData

    [EventType.PaymentCredentialsValidationRequested]: PaymentCredentialsValidationRequestedPayload<
        keyof GatewayCredentialsMap
    >

    [EventType.CategoryAddRequested]: CategoryAddRequestedPayload
    [EventType.CategoryAddConfirmed]: { categoryId: string }
    [EventType.CategoryAddFailed]: { error: string }
    [EventType.CategoryUpdateRequested]: CategoryUpdateRequestedPayload
    [EventType.CategoryUpdateConfirmed]: { categoryId: string }
    [EventType.CategoryUpdateFailed]: { error: string }
    [EventType.CategoryDeleteRequested]: {
        categoryId: string
        auditData?: AuditData
    }
    [EventType.CategoryDeleteConfirmed]: {
        id: string
    }
    [EventType.CategoryDeleteFailed]: {
        error: string
    }
    [EventType.ProductAddRequested]: ProductAddRequestedPayload
    [EventType.ProductAddConfirmed]: { productId: string }
    [EventType.ProductAddFailed]: { error: string }
    [EventType.ProductUpdateRequested]: ProductUpdateRequestedPayload
    [EventType.ProductUpdateConfirmed]: { productId: string }
    [EventType.ProductUpdateFailed]: { error: string }
    [EventType.ProductsDeleteRequested]: {
        productIds: string[]
        auditData?: AuditData
    }
    [EventType.ProductsDeleteResponse]: {
        productIds: string[]
    }
    [EventType.ProductsDeleteFailed]: {
        error: ErrorPayload
    }

    [EventType.OptionGroupsDeleteRequested]: {
        groupIds: string[]
        auditData?: AuditData
    }

    [EventType.OptionGroupsDeleteConfirmed]: {
        groupIds: string[]
    }
    [EventType.OptionGroupsDeleteFailed]: {
        error: ErrorPayload
    }

    [EventType.ModifierGroupsDeleteRequested]: {
        groupIds: string[]
        auditData?: AuditData
    }
    [EventType.ModifierGroupsDeleteConfirmed]: {
        groupIds: string[]
    }
    [EventType.ModifierGroupsDeleteFailed]: {
        error: ErrorPayload
    }

    [EventType.ModifierGroupAddRequested]: ModifierGroupAddRequestedPayload
    [EventType.ModifierGroupAddConfirmed]: ModifierGroupAddResponsePayload
    [EventType.ModifierGroupAddFailed]: ModifierGroupAddResponsePayload

    [EventType.ModifierGroupUpdateRequested]: ModifierGroupUpdateRequestedPayload
    [EventType.ModifierGroupUpdateFailed]: { error: string }
    [EventType.ModifierGroupUpdateConfirmed]: ModifierGroupUpdateResponsePayload

    [EventType.OptionGroupAddRequested]: OptionGroupAddRequestedPayload
    [EventType.OptionGroupAddConfirmed]: OptionGroupAddResponsePayload
    [EventType.OptionGroupAddFailed]: {
        error: ErrorPayload
    }

    [EventType.ModifierAddRequested]: ModifierAddRequestedPayload
    [EventType.ModifierAddConfirmed]: ModifierConfirmedPayload
    [EventType.ModifierAddFailed]: {
        error: ErrorPayload
    }

    [EventType.OnlineOrderingIntegrationRequested]: any
    [EventType.CardProgramSaveRequested]: any
    [EventType.CardProgramDeleteRequested]: { id: string }
    [EventType.UberDirectOrganizationCreateRequested]: any
    [EventType.DomainImportRequested]: {
        domain: string
    }
    [EventType.DomainActivationRequested]: {
        domain: string
    }
    [EventType.DomainDeactivationRequested]: {
        id: string
    }
    [EventType.DomainRemoveRequested]: {
        id: string
    }
    [EventType.DomainImportConfirmed]: any
    [EventType.DomainImportFailed]: any
    [EventType.UberMerchantAuthorizationRequested]: {
        serviceId: string
        uberStoreId: string
    }
    [EventType.TaxCreateRequested]: TaxCreateRequestedPayload
    [EventType.TaxCreateConfirmed]: TaxCreateConfirmedPayload
    [EventType.TaxCreateFailed]: TaxCreateFailedPayload
    [EventType.TaxCreated]: TaxCreatedPayload

    [EventType.TaxUpdateRequested]: TaxUpdateRequestedPayload
    [EventType.TaxUpdateConfirmed]: TaxUpdateConfirmedPayload
    [EventType.TaxUpdateFailed]: TaxUpdateFailedPayload
    [EventType.TaxUpdated]: TaxUpdatedPayload

    [EventType.TaxDeleteRequested]: { id: string; auditData?: AuditData }
    [EventType.TaxDeleteConfirmed]: { id: string }
    [EventType.TaxDeleteFailed]: { id: string; error?: Maybe<string> }
    [EventType.TaxDeleted]: { id: string }

    [EventType.CustomersImportRequested]: {
        fileUrl: string
    }
    [EventType.CustomersImportConfirmed]: Record<string, never>
    [EventType.CustomersImportFailed]: {
        reason: string
    }
    [EventType.CustomerUpdateRequested]: CustomerUpdateRequestedPayload
    [EventType.CustomerUpdateConfirmed]: { id: string }
    [EventType.CustomerUpdateFailed]: { error: ErrorPayload }
    [EventType.CustomerAddressUpdateRequested]: CustomerAddressUpdateRequestedPayload
    [EventType.CustomerAddressUpdateConfirmed]: { id: string }
    [EventType.CustomerAddressUpdateFailed]: { error: ErrorPayload }
    [EventType.CustomerLoyaltyProgramCreateRequested]: CustomerLoyaltyProgramCreateRequestedPayload
    [EventType.CustomerLoyaltyProgramCreateConfirmed]: { id: string }
    [EventType.CustomerLoyaltyProgramCreateFailed]: { error: ErrorPayload }
    [EventType.CustomerLoyaltyProgramRemoveRequested]: CustomerLoyaltyProgramRemoveRequestedPayload
    [EventType.CustomerLoyaltyProgramRemoveConfirmed]: { id: string }
    [EventType.CustomerLoyaltyProgramRemoveFailed]: { error: ErrorPayload }
    [EventType.CustomerDeleteRequested]: CustomerDeleteRequestedPayload
    [EventType.CustomerDeleteConfirmed]: { id: string }
    [EventType.CustomerDeleteFailed]: { error: ErrorPayload }
    [EventType.MenuImportRequested]: MenuImportRequestedPayload
    [EventType.MenuImportConfirmed]: MenuImportConfirmedPayload
    [EventType.MenuImportFailed]: MenuImportFailedPayload

    [EventType.AccountUserAddRequested]: {
        id: string
        email: string
        accountId: string
        accessLevelId?: string
        roleId?: string
        locationIds?: string[]
        firstName?: string
        lastName?: string
    }

    [EventType.AccountUserRemoveRequested]: {
        email: string
    }
    [EventType.AccountInfoUpdateRequested]: {
        id: string
        name?: string
        slug?: string
        domainName?: string
        importance?: number
    }
    [EventType.AccountInfoUpdateConfirmed]: {
        id: string
    }
    [EventType.AccountInfoUpdateFailed]: {
        id?: Maybe<string>
        error: string
    }

    [EventType.AccountUpdateRequested]: Partial<Account> & { id: string }
    [EventType.AccountUpdateFailed]: {
        message: string
    }
    [EventType.AccountUpdateConfirmed]: Partial<Account> & { id: string }

    [EventType.AccessLevelSaveRequested]: AccessLevelSaveRequestedPayload
    [EventType.AccessLevelSaveConfirmed]: AccessLevelSaveConfirmedPayload
    [EventType.AccessLevelDeleteRequested]: AccessLevelDeleteRequestedPayload
    [EventType.AccessLevelDeleteConfirmed]: AccessLevelDeleteConfirmedPayload

    [EventType.TimeRecordCreateRequested]: TimeRecord & {
        breaks?: TimeRecordCreateBreakData[]
    }
    [EventType.TimeRecordCreated]: TimeRecord
    [EventType.TimeRecordCreateFailed]: {
        message: string
    }
    [EventType.TimeRecordCreateConfirmed]: TimeRecord
    [EventType.TimeRecordUpdateRequested]: Partial<TimeRecordUpdateBody> & {
        id: string
        breaks?: Pick<TimeRecordBreakInputBody, "id" | "type" | "startTimestamp" | "endTimestamp">[]
    }
    [EventType.TimeRecordUpdated]: Partial<TimeRecordUpdateBody> & { id: string }
    [EventType.TimeRecordUpdateFailed]: {
        message: string
    }
    [EventType.TimeRecordUpdateConfirmed]: Partial<TimeRecord>
    [EventType.TimeRecordDeleteRequested]: {
        id: string
        editorUserAccountId: Maybe<string>
    }
    [EventType.TimeRecordDeleted]: {
        id: string
        editorUserAccountId: Maybe<string>
    }
    [EventType.TimeRecordDeleteFailed]: {
        message: string
    }
    [EventType.TimeRecordDeleteConfirmed]: {
        id: string
        editorUserAccountId: Maybe<string>
    }

    [EventType.TimeRecordBreakCreateRequested]: TimeRecordBreakInputBody
    [EventType.TimeRecordBreakCreated]: TimeRecordBreakInputBody
    [EventType.TimeRecordBreakCreateFailed]: {
        message: string
    }
    [EventType.TimeRecordBreakCreateConfirmed]: TimeRecordBreakInputBody
    [EventType.TimeRecordBreakUpdateRequested]: Partial<TimeRecordBreakInputBody> & { id: string }
    [EventType.TimeRecordBreakUpdated]: Partial<TimeRecordBreakInputBody> & { id: string }
    [EventType.TimeRecordBreakUpdateFailed]: {
        message: string
    }
    [EventType.TimeRecordBreakUpdateConfirmed]: Partial<TimeRecordBreakInputBody>
    [EventType.TimeRecordBreakDeleteRequested]: {
        id: string
        editorUserAccountId?: string
    }
    [EventType.TimeRecordBreakDeleted]: {
        id: string
        timeRecordLogId?: string
        editorUserAccountId?: string
    }
    [EventType.TimeRecordBreakDeleteFailed]: {
        message: string
    }
    [EventType.TimeRecordBreakDeleteConfirmed]: {
        id: string
    }

    [EventType.CardProgramCardStateUpdateRequested]: {
        id: string
        state: CardState
    }
    [EventType.CardProgramCardStateUpdated]: {
        id: string
        state: CardState
    }
    [EventType.CardProgramCardStateUpdateFailed]: {
        message: string
    }
    [EventType.CardProgramCardStateUpdateConfirmed]: {
        id: string
    }

    [EventType.PasswordResetRequested]: {
        email: string
        callbackUrl?: Maybe<string>
    }
    [EventType.PasswordResetConfirmed]: {
        email: string
    }
    [EventType.PasswordResetFailed]: {
        message: string
    }

    [EventType.PasswordChangeRequested]: {
        email: string
        key: string
        password: string
    }
    [EventType.PasswordChangeFailed]: {
        message: string
    }
    [EventType.PasswordChangeConfirmed]: {
        email: string
    }

    [EventType.SignupRequested]: SignUpRequestedPayload
    [EventType.SignupConfirmed]: SignUpConfirmedPayload
    [EventType.SignupFailed]: {
        message: string
    }

    // Account
    [EventType.AccountCreateRequested]: {
        name: string
        typeOfBusiness: string
        importance: Maybe<number>
        referralAccountId: Maybe<string>
        domainName: Maybe<string>
        organizationId: Maybe<string>
    }
    [EventType.AccountCreateFailed]: {
        message: string
    }
    [EventType.AccountCreated]: {
        account: Account
        user: Maybe<User>
        accessLevels: AccessLevelEventDTO[]
        accessLevelId: string
        phoneNumber: Maybe<string>
    }
    [EventType.AccountCreateConfirmed]: {
        account: Account
    }

    // Organization
    [EventType.OrganizationCreateRequested]: {
        name: string
        type: string
        importance: Maybe<number>
    }
    [EventType.OrganizationCreateConfirmed]: {
        organization: {
            id: string
            name: string
            type: string
            importance: Maybe<number>
        }
    }
    [EventType.OrganizationCreated]: {
        organization: Organization
    }
    [EventType.OrganizationUserAddRequested]: {
        organizationId: string
        email: string
        firstName: string
        lastName: string
        middleName: Maybe<string>
        phoneNumber: Maybe<string>
    }
    [EventType.OrganizationUserAddFailed]: {
        message: string
    }
    [EventType.OrganizationUserAdded]: {
        organizationId: string
        id: string
        user: User
        phoneNumber: Maybe<string>
    }
    [EventType.OrganizationUserAddConfirmed]: OrganizationUserAccount
    [EventType.OrganizationUserRemoveRequested]: {
        id: string
        organizationId: string
    }
    [EventType.OrganizationUserRemoveFailed]: {
        message: string
    }
    [EventType.OrganizationUserRemoved]: {
        id: string
        organizationId: string
    }
    [EventType.OrganizationUserRemoveConfirmed]: {
        id: string
        organizationId: string
    }

    [EventType.SalesInputCreateRequested]: SalesInputCreateRequestedPayload

    [EventType.SalesInputFolderUpdateRequested]: SalesInputFolderUpdateRequestedPayload
    [EventType.SalesInputFolderUpdateFailed]: {
        error?: any
    }
    [EventType.SalesInputFolderUpdateConfirmed]: {
        folderId: string
    }
    [EventType.PromotionCreateRequested]: PromotionCreateRequestedPayload
    [EventType.PromotionCreateFailed]: {
        error: {
            message: string
        }
    }
    [EventType.PromotionCreateConfirmed]: {
        id: string
    }
    [EventType.PromotionUpdateRequested]: PromotionCreateRequestedPayload
    [EventType.PromotionDeleteRequested]: {
        id: string
    }

    [EventType.RoleAddRequested]: RoleEventPayload
    [EventType.RoleUpdateRequested]: Partial<RoleEventPayload>
    [EventType.RoleDeleteRequested]: { id: string }

    [EventType.DepartmentAddRequested]: DepartmentEventPayload
    [EventType.DepartmentUpdateRequested]: DepartmentEventPayload
    [EventType.DepartmentDeleteRequested]: { id: string }

    [EventType.SettingsUpdateRequested]: UpdateSettingsRequestedPayload
    [EventType.SettingsUpdateFailed]: { error: string }
    [EventType.SettingsUpdateConfirmed]: { id: string }

    [EventType.LoyaltyProgramAddRequested]: LoyaltyProgramAddedPayload
    [EventType.LoyaltyProgramUpdateRequested]: LoyaltyProgramUpdatedPayload
    [EventType.LoyaltyProgramDeleteRequested]: LoyaltyProgramDeletedPayload

    [EventType.ExternalServiceIntegrationCreateRequested]: {
        type: "google-business-profile"
        locationId: string
        accountId: string
        googleAccountResourceName: string
        googleLocationResourceName: string
        googleLocationName?: Maybe<string>
    }
    [EventType.ExternalServiceIntegrationRemoved]: {
        type: "google-business-profile"
        locationId: string
    }

    // Google Business Review Reply
    [EventType.GoogleBusinessReviewReplyRequested]: {
        locationId: string
        reviewId: string
        comment: string
    }
    [EventType.GoogleBusinessReviewReplyConfirmed]: {
        locationId: string
        reviewId: string
        reply: {
            comment: string
            updateTime: string
        }
    }
    [EventType.GoogleBusinessReviewReplyFailed]: {
        locationId: string
        reviewId: string
        error: {
            code: string
            message: string
        }
    }
    [EventType.GoogleBusinessReviewReplyDeleteRequested]: {
        locationId: string
        reviewId: string
    }
    [EventType.GoogleBusinessReviewReplyDeleteConfirmed]: {
        locationId: string
        reviewId: string
    }
    [EventType.GoogleBusinessReviewReplyDeleteFailed]: {
        locationId: string
        reviewId: string
        error: {
            code: string
            message: string
        }
    }
    [EventType.TerminalAddRequested]: TerminalAddRequestedPayload
    [EventType.TerminalUpdateRequested]: TerminalUpdateRequestedPayload
    [EventType.TerminalDeleteRequested]: {
        id: string
    }
    [EventType.FigureQrConfigurationSaveRequested]: FigureQrConfigurationSaveRequestedPayload
    [EventType.WaitlistSaveRequested]: WaitlistSaveRequestedPayload

    [EventType.FeatureTracked]: FeatureTrackedPayload
}

export type ProductsDeleteRequestedResponse = {
    productIds: string[]
}

export type ProductsAddRequestedResponse = {
    productId: string
}

export type EventContext = {
    accountId?: string
    locationId?: string
    terminalId?: string
    aggregateType?: string
    aggregateId?: string
    correlationId?: string
}

export interface ErrorPayload {
    message: string
    code: string
}
